import React, { useContext } from 'react';
import { PropTypes } from 'prop-types';

import UnauthorizedRedirect from '@molecules/UnauthorizedRedirect';
import { SearchTypeContext } from '../../../context/searchTypeContext';
import SearchAPIKeyProvider from '@context/SearchAPIKeyProvider';
import useAuthorized from '@hooks/useAuthorized';

const SearchAuthCheck = ({ isAttendeeSearch = false, eventCode, children }) => {
    const [searchType] = useContext(SearchTypeContext);
    const { isLoggedIn } = useAuthorized();

    // attendee search can be viewed by anyone registered for event. Auth check happens in template
    if (isAttendeeSearch) {
        return (
            <SearchAPIKeyProvider isAttendeeSearch={isAttendeeSearch} eventCode={eventCode}>
                {children}
            </SearchAPIKeyProvider>
        );
    }

    const isAuthSearch = searchType.index === 'members' || searchType.index === 'companies';

    if (isAuthSearch && isLoggedIn === false) {
        return <UnauthorizedRedirect />;
    }

    return <SearchAPIKeyProvider>{children}</SearchAPIKeyProvider>;
};

SearchAuthCheck.propTypes = {
    isAttendeeSearch: PropTypes.bool,
    eventCode: PropTypes.string,
    children: PropTypes.element.isRequired,
};

export default SearchAuthCheck;
